// Who-may-see checks read straight from localStorage. Keep this file free of
// imports: the router loads it first, and pulling in utility/index from here
// creates an import cycle (utility/index ↔ commonFunction) that crashes the
// app on start ("Cannot access '__WEBPACK_DEFAULT_EXPORT__' before
// initialization").

/**
 * Who gets the notification bell, live notification toasts and the
 * /notifications inbox. Not Super Admin, not Biller.
 */
export const NO_NOTIFICATION_USER_TYPES = ["SA", "B"];
export const canSeeNotifications = () =>
  !NO_NOTIFICATION_USER_TYPES.includes(localStorage.getItem("userType"));

/**
 * The restricted Super Admin logins, picked by username ("accounts1",
 * "category2" …; see MainLayout permissions). They sign in as SA but must
 * not do full-admin actions such as deleting a PO.
 * @returns "accounts" | "category" | null
 */
export const restrictedSALogin = () => {
  const prefix = `${localStorage.getItem("username") || ""}`.slice(0, -1);
  return prefix === "accounts" || prefix === "category" ? prefix : null;
};
